import React from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog'
import { Button } from '../../../components/ui/button'
import { Input } from '../../../components/ui/input'
import { Search } from 'lucide-react'

const SelectUnscannedChannelsModal = ({
  open,
  onClose,
  liveChannels,
  selectedLiveChannels,
  handleSelectLiveChannel,
  handleSelectAllLiveChannels,
  addSelectedChannels,
  scanSelectedChannels,
  scanningChannels,
}) => {
  const handleClose = () => onClose()

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] flex flex-col bg-white">
        <DialogHeader className="bg-[#44087D] text-white -m-6 mb-0 p-6 rounded-t-lg">
          <DialogTitle className="text-xl font-semibold text-white">
            Select Slack Channels
          </DialogTitle>
        </DialogHeader>

        {/* Search Bar */}
        <div className="relative mb-4">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input type="text" placeholder="Search for unscanned channels" className="pl-10" />
        </div>

        {/* Select All + Counter */}
        <div className="flex items-center justify-between mb-4 pb-2 border-b">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={selectedLiveChannels.length === liveChannels.length && liveChannels.length > 0}
              onChange={(e) => {
                e.stopPropagation();
                handleSelectAllLiveChannels();
              }}
              className="h-4 w-4 text-[#44087D] border-gray-300 rounded focus:ring-[#44087D] focus:ring-2"
            />
            <span className="text-sm font-medium">
              {selectedLiveChannels.length === liveChannels.length && liveChannels.length > 0
                ? 'Deselect all'
                : 'Select all'}
            </span>
          </label>
          {selectedLiveChannels.length > 0 && (
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
              {selectedLiveChannels.length} channel{selectedLiveChannels.length > 1 ? 's' : ''} selected
            </span>
          )}
        </div>

        {/* Channel List */}
        <div className="flex-1 overflow-y-auto min-h-[300px] max-h-[400px] border rounded-md">
          {liveChannels.length === 0 ? (
            <div className="flex items-center justify-center h-32 text-gray-500">
              <p className="text-center">No channels available.</p>
            </div>
          ) : (
            <div className="divide-y">
              {liveChannels.map((channel) => (
                <label
                  key={channel.id}
                  className={`flex items-center gap-3 p-4 cursor-pointer transition-colors ${
                    selectedLiveChannels.some((c) => c.id === channel.id)
                      ? 'bg-purple-50'
                      : 'hover:bg-gray-50'
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={selectedLiveChannels.some((c) => c.id === channel.id)}
                    onChange={() => handleSelectLiveChannel(channel)}
                    className="h-4 w-4 text-[#44087D] border-gray-300 rounded focus:ring-[#44087D] focus:ring-2"
                  />
                  <div className="flex-1 min-w-0" onClick={() => handleSelectLiveChannel(channel)}>
                    <p className="text-sm font-medium text-gray-900 truncate">{channel.is_im ? channel.name : `#${channel.name}`}</p>
                    <p className="text-xs text-gray-500 truncate mt-1">
                      {channel.is_im ? 'Direct Message' : channel.is_mpim ? 'Group DM' : channel.is_private ? 'Private' : 'Public'}
                      {channel.is_member ? ' • Member' : ''}
                      {channel.num_members ? ` • ${channel.num_members} members` : ''}
                      {channel.is_archived ? ' • Archived' : ''}
                    </p>
                  </div>
                </label>
              ))}
            </div>
          )}
        </div>

        <DialogFooter className="mt-6">
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            onClick={addSelectedChannels}
            disabled={selectedLiveChannels.length === 0}
            variant="secondary"
          >
            Add Only ({selectedLiveChannels.length})
          </Button>
          <Button
            onClick={scanSelectedChannels}
            disabled={selectedLiveChannels.length === 0 || scanningChannels}
            className="bg-[#44087D] hover:bg-[#5a0a9a] text-white"
          >
            {scanningChannels ? 'Scanning Channels...' : `Scan Selected Channels (${selectedLiveChannels.length})`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default SelectUnscannedChannelsModal


